export default "__VITE_ASSET__DlhJxwwH__"